import { Index, useHits } from 'react-instantsearch';

import getConfig from '@/configs/global';

const {
  publicRuntimeConfig: { NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX_NAME },
} = getConfig();
const indexName = NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX_NAME;

function CategoryHits({ render }) {
  const { items } = useHits();

  return render(items);
}

/**
 * Renders a list of product categories.
 * This component is a wrapper around the Algolia Index component.
 * @returns {JSX.Element} - The rendered component.
 */
function CategorySearch({ render }) {
  if (!indexName) return null;

  return (
    <Index indexName={indexName}>
      <CategoryHits render={render} />
    </Index>
  );
}

export default CategorySearch;
